import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DuckBadge } from "@/components/DuckMascot";
import { Reveal } from "@/components/Reveal";

// Reusable conversion block. Variant "dark" for forest, "amber" for terracotta.
export default function CTABlock({
  eyebrow,
  title,
  body,
  primary,
  secondary,
  variant = "dark",
  showDuck = true,
}) {
  const dark = variant === "dark";
  return (
    <Reveal>
      <div
        className={`relative overflow-hidden rounded-[2rem] px-6 py-14 sm:px-14 sm:py-20 grain ${
          dark ? "bg-forest-950 text-cream" : "bg-terracotta text-white"
        }`}
        data-testid="cta-block"
      >
        <div
          className="absolute -right-16 -top-16 w-72 h-72 rounded-full opacity-20"
          style={{ background: dark ? "#22C55E" : "#FDFBF7" }}
        />
        <div className="absolute -left-10 -bottom-20 w-80 h-80 rounded-full opacity-10 bg-cream" />
        <div className="relative max-w-3xl">
          {showDuck && (
            <div className="mb-6">
              <DuckBadge size={64} />
            </div>
          )}
          {eyebrow && (
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] opacity-70">{eyebrow}</span>
          )}
          <h2 className={`mt-3 font-serif font-bold ${dark ? "text-cream" : "text-white"} text-3xl sm:text-4xl lg:text-5xl leading-[1.1]`}>
            {title}
          </h2>
          {body && <p className="mt-5 text-base sm:text-lg opacity-85 leading-relaxed max-w-2xl">{body}</p>}
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            {primary && (
              <Link
                to={primary.to}
                className={`inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold transition-all active:scale-95 ${
                  dark ? "bg-duckgreen text-forest-950 hover:bg-duckgreen/90" : "bg-forest-950 text-cream hover:bg-forest"
                }`}
                data-testid="cta-primary"
              >
                {primary.label}
                <ArrowRight className="w-4 h-4" />
              </Link>
            )}
            {secondary && (
              <Link
                to={secondary.to}
                className={`inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold border transition-all active:scale-95 ${
                  dark ? "border-cream/30 text-cream hover:bg-cream/10" : "border-white/40 text-white hover:bg-white/10"
                }`}
                data-testid="cta-secondary"
              >
                {secondary.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </Reveal>
  );
}
